import { DatePicker, DateTimePicker } from "@progress/kendo-react-dateinputs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from "../../../constant";
import { ToastContainer, toast } from "react-toastify";
import AppContext from "../../../AppContext";
import { useTranslation } from "react-i18next";

const FuelForm = () => {
  const { getTimeZoneDateTime, authCtx, superAdminCompany, darkMode } =
    useContext(AppContext);
  const defaultForm = {
    fuelType: "Petrol",
    date: getTimeZoneDateTime(new Date()),
    value: 0,
    currency: "",
    active: true,
    companyId: authCtx.profile?.companyId,
    companyName: authCtx.profile?.companyName,
  };
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [fuel, setFuel] = useState(defaultForm);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = async (companyData) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/Fuel/${id}`);
      setFuel({
        ...res.data,
        date: new Date(res.data.date),
        // company: companyData.find((x) => x.id === res.data.companyId),
      });
    } catch (err) {
      if (err.response?.status === 400) toast.error(err.response.data);
      // else toast.error("An error occured");
    }
  };

  const onSave = async () => {
    try {
      setLoading(true);
      const payload = {
        ...fuel,
        companyId: authCtx.profile.companyId,
      };
      const res = await axios.post(`${BASE_URL}/api/Fuel`, payload);
      if (res.status === 200) {
        toast.success("Fuel Saved Successfully");
        navigate(`/fuelform/${res.data.id}`);
      } else {
        toast.error("Some Error Occured While Saving");
      }
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error(error.response.data);
      } else {
        toast.error("An error occurred");
      }
    }
    setLoading(true);
  };

  const onCloseClick = () => {
    navigate("/fuellist");
  };

  const onHandleChange = (e) => {
    setFuel((pre) => ({ ...pre, [e.target.name]: e.target.value }));
  };

  const onCheckBoxChange = (e) => {
    setFuel((pre) => ({ ...pre, [e.target.name]: e.target.checked }));
  };

  const loadCompanyCurrency = async () => {
    const companyId = authCtx.profile.companyId;
    if (companyId !== null) {
      const res = await axios.get(`${BASE_URL}/api/CompanyMaster/${companyId}`);
      if (res.status === 200) {
        setFuel((pre) => ({
          ...pre,
          companyId: res.data.id,
          companyName: res.data.name,
          company: res.data,
          currency: res.data.currency,
        }));
      }
    }
  };

  const loadLookupData = async () => {
    let res = await axios.get(`${BASE_URL}/api/CompanyMaster`);
    if (res.status === 200) {
      const data = res.data;
      setCompanies(data);
      return data;
    }
  };

  useEffect(() => {
    const loadFunctions = async () => {
      // const companyData = await loadLookupData();
      if (id !== "new") loadData();
      else loadCompanyCurrency();
    };
    loadFunctions();
    // if (authCtx.profile.role === 100) loadCompanies();
  }, []);

  const handleCompanyChange = (e) => {
    setFuel((pre) => ({
      ...pre,
      company: e.value,
      companyId: e.value.id,
      companyName: e.value.name,
      currency: e.value.currency,
    }));
  };

  return (
    <div className="flex flex-col relative text-white px-14 py-7 dark:bg-darkModeBg bg-lightModeBg h-full">
      <div className="flex text-xs font-medium gap-3 items-center justify-between">
        <div className="flex items-center gap-3">
          <button type="button" onClick={onCloseClick}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke={darkMode ? "white" : "black"}
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
          </button>
          <label className="dark:text-white text-labels">
            {t("button.addFuel")}
          </label>
          <div className="flex h-10 w-10  bg-gray2 justify-center items-center rounded-full">
            <img
              src="fuel-pump.svg"
              alt="VehicleImage"
              className=" w-5 hover:fill-white"
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col text-xs font-medium py-4 gap-3">
        <div className="flex flex-col">
          <label className="dark:text-white text-labels text-sm font-medium py-2">
            {t("masters.fields.fuelType")}
          </label>
          <div
            className={` w-40 lg:w-96 h-9 ${
              darkMode ? "darkCombo" : "lightCombo"
            }`}
          >
            <ComboBox
              data={["Petrol", "Diesel"]}
              name="fuelType"
              suggest={true}
              clearButton={false}
              style={{ fontSize: "12px", fontWeight: "500" }}
              className=" h-full w-full md:text-xs text-xxs dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts"
              onChange={onHandleChange}
              value={fuel.fuelType}
            />
          </div>
        </div>
        <div className="flex flex-col">
          <label className="dark:text-white text-labels text-sm font-medium py-2">
            {t("masters.fields.date")}
          </label>
          <div
            className={`w-40 lg:w-96 h-9 ${
              darkMode ? "darkCombo" : "lightCombo"
            }`}
          >
            <DatePicker
              className=" h-full w-full md:text-xs text-xxs dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts"
              placeholder="Start Range"
              format="dd-MM-yyyy"
              value={fuel.date}
              onChange={(e) =>
                setFuel((pre) => ({
                  ...pre,
                  date: e.target.value,
                }))
              }
            />
          </div>
        </div>
        <div className="flex flex-col">
          <label className="dark:text-white text-labels text-sm font-medium py-2">
            {t("masters.fields.value")}
          </label>
          <div className="flex w-40 lg:w-96 gap-1">
            <input
              type="number"
              className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts disabled:opacity-40 focus:outline-none border-grey-light rounded-lg dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-full h-9"
              onChange={(e) =>
                setFuel((pre) => ({ ...pre, value: e.target.value }))
              }
              value={fuel.value}
              disabled={!fuel.companyId}
            />
            <div className="dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg flex justify-center items-center dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-3 h-9">
              {fuel?.currency || "..."}
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center mt-4">
        <button
          type="button"
          name="Cancel"
          className="dark:bg-white bg-closeBtns dark:text-black text-closeBtnTxts text-sm rounded-4xl w-48 h-9 justify-center mr-3"
          onClick={onCloseClick}
        >
          {t("button.cancel")}
        </button>
        <button
          type="button"
          name="create"
          className="dark:bg-indigo-700 bg-submitBtns disabled:opacity-40 dark:text-white text-submitBtnTxts text-sm rounded-4xl w-48 h-9 justify-center"
          onClick={onSave}
          disabled={loading || !fuel.companyId || !fuel.value}
        >
          {t("button.save")}
        </button>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ToastContainer />
    </div>
  );
};

export default FuelForm;
